<form autocomplete="nope" class="material" #form="ngForm">
    <!-- File Upload -->
    <div
        class="file-drop"
        [class.invalid]="file.errors && form.submitted"
        *ngIf="file.value || !companyDocument?.fileId"
    >
        <app-file-drop
            (filesSelected)="onFileSelected($event)"
            *ngIf="!file.value"
            [allowedTypes]="['.pdf']"
            [required]="true"
            [maxFileSize]="30"
        ></app-file-drop>
        <div class="supported-upload">
            {{ 'document.supportedFormats' | translate }}
            <span class="support-divider">|</span>
            {{ 'document.maxSize' | translate }}
        </div>

        <mat-error *ngIf="file.errors && form.submitted">
            <span>{{ file.errors | formErrors }}</span>
        </mat-error>
        <div class="field" *ngIf="file.value">
            <label
                ><span>{{ file.value.name }}</span>
                <img (click)="onFileRemoved()" appIcon="CrossGreyUiOutline" />
            </label>
            <div class="ui divider"></div>
        </div>
    </div>

    <mat-form-field>
        <mat-label>{{ 'forms.company-document.documentName' | translate }}</mat-label>
        <input
            type="text"
            required
            name="companyDocumentName"
            [(ngModel)]="companyDocument.name"
            #docName="ngModel"
            matInput
        />
        <mat-error *ngIf="docName.invalid">{{ docName.errors | formErrors }}</mat-error>
    </mat-form-field>

    <ui-chips-autocomplete
        #tagAutocomplete
        label="{{ 'forms.company-document.tags' | translate }}"
        placeholder="{{ 'forms.company-document.addATag' | translate }}"
        [allowAdditions]="true"
        [autocompleteItems]="allTags"
        [selectedItems]="companyDocument.documentTags"
    ></ui-chips-autocomplete>

    <mat-checkbox
        *ngIf="!companyDocument?.isSigningDocument() && showPublicCheckbox"
        [color]="'primary'"
        name="isPublic"
        [(ngModel)]="companyDocument.isPublic"
        >{{ 'forms.company-document.makeThisAPublicDocument' | translate }}
        <ui-info text="{{ 'forms.company-document.publicDocumentsNotice' | translate }}"></ui-info>
    </mat-checkbox>

    <mat-form-field *ngIf="showCosigners">
        <mat-label appRemoveAriaOwns>
            {{ 'forms.company-document.numberOfCosigners' | translate }}
        </mat-label>
        <span class="cosigners-count-label">{{ cosignersLabel.key | translate: { count: cosignersLabel.count } }}</span>
        <mat-select name="cosigners" [(ngModel)]="cosigners" (selectionChange)="onCosignersChange()">
            <mat-option [value]="0">{{ 'forms.company-document.noCosigners' | translate }}</mat-option>
            <mat-option [value]="1">1</mat-option>
            <mat-option [value]="2">2</mat-option>
            <mat-option [value]="3">3</mat-option>
        </mat-select>
    </mat-form-field>
</form>
